import * as React from 'react'
import clsx from 'clsx'
import useStyles from './style'
import { Box } from '@mui/system'

type Props = {
  children: React.ReactNode
  center?: boolean
  paddingZero?: boolean
}

const Main = ({ children, center = false, paddingZero = false }: Props) => {
  const { classes } = useStyles()

  return (
    <Box
      className={clsx({
        [classes.center]: center,
        [classes.paddingZero]: paddingZero,
        [classes.root]: !center && !paddingZero,
      })}
    >
      {children}
    </Box>
  )
}

export default Main
